import { GameFontStyle } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/style/GameFontStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { HorizontalLayout } from "@lib/titan2/dist/game/control/layout/HorizontalLayout";
import { VerticalLayout } from "@lib/titan2/dist/game/control/layout/VerticalLayout";
import { ButtonProperties } from "@lib/titan2/dist/game/control/properties/ButtonProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { CommonLang } from "@lib/titan2/dist/game/view/lang/CommonLang";
import { AbstractResponsibleGamingDialogProperties } from "@lib/titan2/dist/game/view/properties/AbstractResponsibleGamingDialogProperties";
import { AbstractResponsibleGamingPanelProperties } from "@lib/titan2/dist/game/view/properties/AbstractResponsibleGamingPanelProperties";
import { CommonStyle } from "@lib/titan2/dist/game/view/style/CommonStyle";
import * as PIXI from "pixi.js";
/**
 * ResponsibleGamingDialogProperties.ts
 */
export class ResponsibleGamingDialogProperties extends AbstractResponsibleGamingDialogProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.panelProperties.position = new PIXI.Point(162, 70);
        this.panelProperties.layout = new VerticalLayout(30);
        this.cancelButtonProperties = new ButtonProperties(CommonStyle.DIALOG_BUTTON_2, CommonStyle.MODULE, new PIXI.Point(224, 880));
        this.cancelButtonProperties.textFieldProperties = new TextFieldProperties(GameFontStyle.PLAYER_CONTROL_BUTTONS, null, CommonLang.CANCEL_BUTTON);
        this.cancelButtonProperties.textFieldProperties.size = new PIXI.Point(145, 60);
        this.cancelButtonProperties.textFieldOffset.set(0, -8);
        this.confirmButtonProperties = new ButtonProperties(CommonStyle.DIALOG_BUTTON_2, CommonStyle.MODULE, new PIXI.Point(512, 880));
        this.confirmButtonProperties.textFieldProperties = new TextFieldProperties(GameFontStyle.PLAYER_CONTROL_BUTTONS, null, CommonLang.SAVE_BUTTON);
        this.confirmButtonProperties.textFieldProperties.size = new PIXI.Point(145, 60);
        this.confirmButtonProperties.textFieldOffset.set(0, -8);
        this.extraSpinPanelProperties = new ResponsibleGamingPanelProperties(CommonLang.RESPONSIBLE_GAMING_EXTRA_SPIN);
        this.spinPricePanelProperties = new ResponsibleGamingPanelProperties(CommonLang.RESPONSIBLE_GAMING_SPIN_PRICE);
        this.singleGameStakePanelProperties = new ResponsibleGamingPanelProperties(CommonLang.RESPONSIBLE_GAMING_SINGLE_GAME_STAKE);
        this.maximumLossPanelProperties = new ResponsibleGamingPanelProperties(CommonLang.RESPONSIBLE_GAMING_MAXIMUM_LOSS);
    }
}
export class ResponsibleGamingPanelProperties extends AbstractResponsibleGamingPanelProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.titleFieldProperties.position = new PIXI.Point(310, 0);
        this.titleFieldProperties.size = new PIXI.Point(500, 50);
        this.titleFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.panelProperties.position = new PIXI.Point(260, 50);
        this.panelProperties.layout = new HorizontalLayout(45, ControlConstants.CENTER);
        this.optionProperties.textFieldProperties.size = new PIXI.Point(70, 70);
    }
}
